module.exports = __webpack_public_path__ + "img/training_mix3.e23f1aaa.jpg";